<template>
  <a-row :gutter="24">
    <a-col :span="12">
      <a-form-model-item
        label="是否有物业管理费"
        prop="hasPropertyManagementFee"
      >
        <a-radio-group v-model="form.hasPropertyManagementFee" :disabled="!isEditable">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="水电气热等费用" prop="utilityFee">
        <a-radio-group v-model="form.utilityFee" :disabled="!isEditable">
          <a-radio :value="1">承租方直接支付</a-radio>
          <a-radio :value="2">其他</a-radio>
        </a-radio-group>
        <a-form-model-item prop="utilityFeeDesc" v-if="form.utilityFee === 2">
          <a-input v-model="form.utilityFeeDesc" placeholder="请输入水电气等费用其他说明" :disabled="!isEditable"/>
        </a-form-model-item>
      </a-form-model-item>
    </a-col>

    <a-col :span="24" v-if="form.hasPropertyManagementFee == 1">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="物业管理费缴纳方式"
            prop="propertyManagementFeeWay"
          >
            <a-radio-group v-model="form.propertyManagementFeeWay" :disabled="!isEditable">
              <a-radio :value="1">由承租方直接与物业结算</a-radio>
              <a-radio :value="2">其他</a-radio>
            </a-radio-group>
            <a-form-model-item
              prop="propertyManagementFeeWayDesc"
              v-if="form.propertyManagementFeeWay === 2"
            >
              <a-textarea
                placeholder="请输入物业管理费缴纳方式其他说明"
                v-model="form.propertyManagementFeeWayDesc"
                :rows="1"
                :disabled="!isEditable"
              />
            </a-form-model-item>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="物业管理费金额"
            prop="propertyManagementFee"
          >
            <a-form-model-item
              prop="propertyManagementFee"
              :style="{
                display: 'inline-block',
                width: 'calc(100% - 300px)',
              }"
            >
              <a-input
                v-model="form.propertyManagementFee"
                placeholder="请输入物业管理费金额"
                :disabled="!isEditable"
              />
            </a-form-model-item>
            <span
              :style="{
                display: 'inline-block',
                width: '10px',
                textAlign: 'center',
              }"
            >
            </span>
            <a-form-model-item
              prop="propertyManagementFeeUnit"
              :style="{
                display: 'inline-block',
                width: '280px',
              }"
            >
              <a-radio-group
                v-model="form.propertyManagementFeeUnit"
                button-style="solid"
                :disabled="!isEditable"
              >
                <a-radio-button :value="1"> 元/㎡/天 </a-radio-button>
                <a-radio-button :value="2"> 元/㎡/月 </a-radio-button>
                <a-radio-button :value="3"> 元/年 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="服务费付款主体" prop="paymentSubject">
            <a-radio-group v-model="form.paymentSubject" :disabled="!isEditable">
              <a-radio :value="1">承租方</a-radio>
              <a-radio :value="2">出租方</a-radio>
              <a-radio :value="3">双方各付</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="服务费">
        <a-input
          placeholder="租赁期限在3年以下的，按照首年首月租金成交价格的0.5倍收取；租赁期限在3年及以上的，按照首年首月租金成交价格的1倍收取"
          disabled
        />
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>

<style>
</style>